(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[495],{

/***/ 51808:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ register; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/components/Footer/Footer.tsx
var Footer = __webpack_require__(91001);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/@mui/styled-engine/StyledEngineProvider/StyledEngineProvider.js
var StyledEngineProvider = __webpack_require__(94810);
// EXTERNAL MODULE: ./src/components/index.ts + 109 modules
var components = __webpack_require__(1356);
// EXTERNAL MODULE: ./src/pages/Register/Register.styles.ts
var Register_styles = __webpack_require__(85614);
// EXTERNAL MODULE: ./src/components/Register/index.ts + 3 modules
var components_Register = __webpack_require__(1837);
// EXTERNAL MODULE: ./src/components/Register/DateOfBirth/DateOfBirth.tsx
var DateOfBirth = __webpack_require__(44404);
// EXTERNAL MODULE: ./src/components/Register/Address/Address.tsx + 1 modules
var Address = __webpack_require__(21492);
// EXTERNAL MODULE: ./src/components/Register/Accessibility/Accessibility.tsx
var Accessibility = __webpack_require__(76087);
// EXTERNAL MODULE: ./src/components/Register/Gender/Gender.tsx + 1 modules
var Gender = __webpack_require__(98361);
// EXTERNAL MODULE: ./src/components/Register/PhoneNumber/PhoneNumber.tsx
var PhoneNumber = __webpack_require__(92788);
// EXTERNAL MODULE: ./src/components/Register/Success/Success.styles.ts
var Success_styles = __webpack_require__(46784);
// EXTERNAL MODULE: ./src/components/TitleSubtitle/TitleSubtitle.tsx + 2 modules
var TitleSubtitle = __webpack_require__(33911);
// EXTERNAL MODULE: ./src/services/ShowService.tsx
var ShowService = __webpack_require__(90774);
// EXTERNAL MODULE: ./src/utils/constants.tsx
var constants = __webpack_require__(39509);
// EXTERNAL MODULE: ./src/utils/string-utils.tsx
var string_utils = __webpack_require__(46955);
// EXTERNAL MODULE: ./src/contexts/RegisterContext.tsx
var RegisterContext = __webpack_require__(72078);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/Register/Success/Success.tsx













var Success = function Success(_ref) {
  var firstName = _ref.firstName;

  var _useRegisterContext = (0,RegisterContext/* useRegisterContext */.$)(),
      registerInfo = _useRegisterContext.registerInfo;

  var displayFirstName = firstName || registerInfo.user.firstName || '';

  var _useState = (0,react.useState)(""),
      upcomingShowUrl = _useState[0],
      setUpcomingShowUrl = _useState[1];

  var _useState2 = (0,react.useState)(null),
      redirectUrl = _useState2[0],
      setRedirectUrl = _useState2[1];

  (0,ShowService/* readUpcomingShow */.TV)().then(function (upcomingShow) {
    if (upcomingShow.data) {
      var _upcomingShow$data;

      setUpcomingShowUrl((_upcomingShow$data = upcomingShow.data) === null || _upcomingShow$data === void 0 ? void 0 : _upcomingShow$data.publicRouteUrL);
    }
  });
  (0,react.useEffect)(function () {
    // Read once and clear straight away: a value left behind in localStorage used to
    // survive into later, unrelated sessions and hijack this screen — which is what
    // made the old "Continue" button look buggy.
    var storedRedirectUrl = window.localStorage.getItem("redirectURL");
    window.localStorage.removeItem("redirectURL"); // Never bounce back into an auth page — that is a loop, not a return trip.

    if (storedRedirectUrl && !/\/(login|register|reset-password)/.test(storedRedirectUrl)) {
      setRedirectUrl(storedRedirectUrl);
    }
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Success_styles/* SuccessContainer */.qL, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Success_styles/* ImageContainer */.mo, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
        fill: true,
        alt: "Party Bird - TTT",
        src: "/images/email/gifs/party_bird.gif"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(TitleSubtitle/* TitleSubtitle */.V, {
      "data-cy": "success-title-subtitle",
      size: "sm",
      centered: true,
      title: (0,string_utils/* formatString */.Uw)(constants/* welcomeMessageTemplate */.UR, displayFirstName),
      subTitle: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "You\u2019ve just unlocked the ", /*#__PURE__*/(0,jsx_runtime.jsx)(Success_styles/* BoldWhiteSpan */.qI, {
          children: "best-kept secret"
        }), " in television!", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "Forget the couch; you\u2019re not just a viewer - you\u2019re a \u2B50 of the show!\xA0", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "You\u2019ll now be the first to know about  ", /*#__PURE__*/(0,jsx_runtime.jsx)(Success_styles/* BoldWhiteSpan */.qI, {
          children: "free tickets"
        }), " to upcoming shows.", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "We often drop a cheeky last-minute ticket on our socials - ", /*#__PURE__*/(0,jsx_runtime.jsx)(Success_styles/* BoldWhiteSpan */.qI, {
          children: "follow us"
        }), " for the inside scoop.", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "#TTTicketAU"]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Success_styles/* CTAForthContainer */.Uh, {
      children: [redirectUrl ? /*#__PURE__*/(0,jsx_runtime.jsx)(Success_styles/* CustomSubmitButton */.Yf, {
        "data-cy": "register-continue-button",
        onClick: function onClick() {
          return router_default().push(redirectUrl);
        },
        full: true,
        children: "Continue"
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(Success_styles/* CustomSubmitButton */.Yf, {
        onClick: function onClick() {
          return router_default().push("/audience");
        },
        full: true,
        children: "Explore Upcoming Shows"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Success_styles/* CustomSubmitButton */.Yf, {
        onClick: function onClick() {
          return router_default().push("/profile?tab=tickets");
        },
        full: true,
        children: "I\u2019ve Already Got a Ticket Offer"
      })]
    })]
  });
};

Success.displayName = "Success";
var ComponentWithRouter = (0,router.withRouter)(Success);

// EXTERNAL MODULE: ./src/components/Register/PhoneNumberVerification/PhoneNumberVerification.tsx
var PhoneNumberVerification = __webpack_require__(61677);
;// CONCATENATED MODULE: ./src/pages/Register/Register.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


















var Register = function Register(_ref) {
  var router = _ref.router,
      currentStep = _ref.currentStep,
      email = _ref.email,
      firstName = _ref.firstName;

  var _useRegisterContext = (0,RegisterContext/* useRegisterContext */.$)(),
      setRegisterInfo = _useRegisterContext.setRegisterInfo;

  var stepSize = 10;

  var _useState = (0,react.useState)(currentStep ? currentStep : 0),
      step = _useState[0],
      setStep = _useState[1];

  (0,react.useEffect)(function () {
    setRegisterInfo(function (prevRegisterInfo) {
      return _objectSpread(_objectSpread({}, prevRegisterInfo), {}, {
        user: _objectSpread(_objectSpread({}, prevRegisterInfo.user), {}, {
          email: email ? email : ""
        })
      });
    });
  }, []);

  var nextStep = function nextStep() {
    setStep(step + 1);
  };

  var prevStep = function prevStep() {
    setStep(step - 1);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledEngineProvider/* default */.Z, {
    injectFirst: true,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* NavigationBar */.vx, {
      showHomeIconOnMobile: step !== 0 && step !== stepSize - 1,
      showLoginButton: step === 0,
      showMenu: step === 0 || step === stepSize - 1,
      showRegisterButton: false,
      children: step !== 0 && step !== stepSize - 1 && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Stepper */.vF, {
        stepSize: stepSize,
        activeStepIndex: step
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Register_styles/* RegisterContainer */.K0, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Register_styles/* RegisterStepsContainer */.wW, {
        children: [step === 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(components_Register/* BasicInfo */.Kz, {
          onNextButtonClick: nextStep
        }), step === 1 && /*#__PURE__*/(0,jsx_runtime.jsx)(components_Register/* EmailVerification */.My, {
          onNextButtonClick: nextStep,
          onPrevButtonClick: prevStep
        }), step === 2 && /*#__PURE__*/(0,jsx_runtime.jsx)(components_Register/* Password */.ro, {
          onNextButtonClick: nextStep
        }), step === 3 && /*#__PURE__*/(0,jsx_runtime.jsx)(DateOfBirth/* DateOfBirth */.n, {
          onNextButtonClick: nextStep,
          onPrevButtonClick: prevStep
        }), step === 4 && /*#__PURE__*/(0,jsx_runtime.jsx)(Address/* Address */.k, {
          onNextButtonClick: nextStep,
          onPrevButtonClick: prevStep
        }), step === 5 && /*#__PURE__*/(0,jsx_runtime.jsx)(Accessibility/* Accessibility */.y, {
          onNextButtonClick: nextStep,
          onPrevButtonClick: prevStep
        }), step === 6 && /*#__PURE__*/(0,jsx_runtime.jsx)(Gender/* Gender */.Y, {
          onNextButtonClick: nextStep,
          onPrevButtonClick: prevStep
        }), step === 7 && /*#__PURE__*/(0,jsx_runtime.jsx)(PhoneNumber/* PhoneNumber */.B, {
          onNextButtonClick: nextStep,
          onPrevButtonClick: prevStep
        }), step === 8 && /*#__PURE__*/(0,jsx_runtime.jsx)(PhoneNumberVerification/* PhoneNumberVerification */.v, {
          onNextButtonClick: nextStep,
          onPrevButtonClick: prevStep
        }), step === 9 && /*#__PURE__*/(0,jsx_runtime.jsx)(ComponentWithRouter, {
          firstName: firstName
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* MeshGradient */.bL, {
        sx: {
          position: 'fixed'
        },
        colour: "teal-green",
        position: "bottom",
        size: "low"
      })]
    })]
  });
};

/* harmony default export */ var Register_Register = ((0,router.withRouter)(Register));
// EXTERNAL MODULE: ./src/contexts/CustomThemeProvider.tsx + 2 modules
var CustomThemeProvider = __webpack_require__(75044);
;// CONCATENATED MODULE: ./pages/register.tsx











var RegisterPage = function RegisterPage(_ref) {
  var router = _ref.router;
  var seoTitle = "Register | That's The Ticket";

  var _useColorModeContext = (0,CustomThemeProvider/* useColorModeContext */.XE)(),
      setColorMode = _useColorModeContext.setColorMode;

  setColorMode("dark");
  var step = Number(router.query.step);
  var email = router.query.email;
  var firstName = router.query.firstName; // Registration spans several steps and its own context, so the return target is parked
  // in localStorage the same way the login page does it — the success screen picks it up.
  // Lets an expired-offer link send a never-registered guest through sign-up and back to
  // their rejoin (TTT-687).

  (0,react.useEffect)(function () {
    var redirectURL = router.query.redirectURL;

    if (redirectURL) {
      window.localStorage.setItem("redirectURL", redirectURL.toString());
    }
  }, [router.query]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: "".concat(seoTitle)
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:title",
        content: seoTitle
      }, "ogTitle"), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "twitter:title",
        content: seoTitle
      }, "twitterTitle")]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(RegisterContext/* RegisterProvider */.l, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Register_Register, {
        currentStep: step,
        email: email,
        firstName: firstName
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {})]
  });
};

var __N_SSP = true;
/* harmony default export */ var register = ((0,router.withRouter)(RegisterPage));

/***/ }),

/***/ 46784:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Uh": function() { return /* binding */ CTAForthContainer; },
/* harmony export */   "Yf": function() { return /* binding */ CustomSubmitButton; },
/* harmony export */   "mo": function() { return /* binding */ ImageContainer; },
/* harmony export */   "qI": function() { return /* binding */ BoldWhiteSpan; },
/* harmony export */   "qL": function() { return /* binding */ SuccessContainer; }
/* harmony export */ });
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90948);
/* harmony import */ var _Button_Button__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21869);


var SuccessContainer = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)("div")(function (_ref) {
  var theme = _ref.theme;
  return {
    display: "flex",
    width: theme.space._1400,
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: theme.space._600,
    alignSelf: "stretch",
    "@media (max-width: 600px)": {
      width: "100%"
    }
  };
});
var ImageContainer = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)("div")(function (_ref2) {
  var theme = _ref2.theme;
  return {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    alignSelf: "center",
    width: "12.5rem",
    height: "8.5rem",
    position: "relative"
  };
});
var BoldWhiteSpan = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)("span")(function (_ref3) {
  var theme = _ref3.theme;
  return {
    color: theme.colors["neutral.50"],
    fontWeight: theme.fontWeights.bold
  };
});
var CustomSubmitButton = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_Button_Button__WEBPACK_IMPORTED_MODULE_0__/* .Button */ .z)(function (_ref4) {
  var theme = _ref4.theme;
  return {
    display: "flex",
    padding: "1rem 1.5rem",
    justifyContent: "center",
    alignItems: "center",
    gap: "0.5rem",
    alignSelf: "stretch"
  };
});
var CTAForthContainer = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)("div")(function (_ref5) {
  var theme = _ref5.theme;
  return {
    display: "flex",
    paddingTop: theme.space._200,
    justifyContent: "center",
    alignItems: "center",
    gap: theme.space._600,
    alignSelf: "center",
    width: theme.space._1300,
    flexDirection: "column",
    "@media (max-width: 600px)": {
      width: "100%"
    }
  };
});

/***/ }),

/***/ 54722:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/register",
      function () {
        return __webpack_require__(51808);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(16505)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9765,961,6470,9774,2888,179], function() { return __webpack_exec__(54722); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);